module.exports = __webpack_public_path__ + "ptc_nakagawa_I2.daa14d0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_I2.jpg
// module id = vNzd
// module chunks = 0